import React, { useState } from 'react';
import { ArcCollapse, ArcStack, ArcText } from '@src/core/ui';
import { ReactComponent as ArrowUpIcon } from '@src/assets/icons/arrow-up.svg';
import { ToggleCollapseViewProps } from './types';

const ToggleCollapseView: React.FC<ToggleCollapseViewProps> = (props) => {
  const { children, label, defaultOpen, sx } = props;

  const [open, setOpen] = useState(defaultOpen ?? true);

  const onToggleCollapse = () => {
    setOpen(!open);
  };

  const onClick = () => {
    onToggleCollapse();
  };

  const renderIcon = () => {
 
    return (
      <ArrowUpIcon width={18} style={{
        transform: `rotate(${open ? '0deg' : '180deg'})`,
        transition: 'transform 0.3s',
      }}  />
    );
  };

  return (
    <ArcStack marginTop={2} sx={sx}>
      <ArcStack 
        spacing={1} 
        direction='row' 
        alignItems='center'
        justifyContent='space-between'
        sx={{ cursor: 'pointer' }}
        onClick={onClick}>

        <ArcText.h5 color='text.secondary' fontSize={12}>{label}</ArcText.h5>
        {renderIcon()}
      </ArcStack>

      <ArcCollapse in={open} timeout="auto" unmountOnExit={false}>
        {children}
      </ArcCollapse>
    </ArcStack>
  );
};

export default ToggleCollapseView;
